import { Component, OnInit, Input } from '@angular/core';
import { UploadFileService } from 'src/app/services/upload-file.service';
import { GlobalService } from 'src/app/services/global.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-uploadfile',
  templateUrl: './uploadfile.component.html',
  styleUrls: ['./uploadfile.component.css']
})
export class UploadfileComponent implements OnInit {
  @Input() id

  //string
  token: string

  //formData
  uploadForm: FormGroup;
  formData: any;

  //array
  file: Array<any> = [];
  nameList: Array<any> = [];

  constructor(
    private upload: UploadFileService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private globals: GlobalService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    if(!this.token){
      this.token = this.globals.getToken();
    }
    this.uploadForm = this.formBuilder.group({
      profile: ['']
    });
  }

  onFileSelect(event) {
    let amount = event.target.files.length
    if (event.target.files.length > 0 && event.target.files[0]) {
      this.file = event.target.files

      Array.from(event.target.files).forEach(file => {
        this.nameList.push(file)
      });
    }
  }

  uploadFile() {

    this.uploadForm.get('profile').setValue(this.file);
      const formData = new FormData();
      for(let i = 0; i < this.file.length; i++){
        formData.append('file', this.file[i], this.file[i].name);
      }
      this.upload.uploadFile(this.token, this.id, formData).subscribe(
        res => {
          this.activeModal.close();
        },
        err => { console.error(err) }
      );

  }

  svuota() {
    this.file = null;
    this.nameList = [];
  }

  canceling(){
    this.activeModal.close('Cancel');
  }

}
